module.exports = __webpack_public_path__ + "824263626642d648c77751cb011c7df8.png";